var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
var defaultOptions = {};
export var ProgressFieldsFragmentDoc = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment progressFields on progress {\n  id\n  CurrentStep\n  CurrentState\n}\n    "], ["\n    fragment progressFields on progress {\n  id\n  CurrentStep\n  CurrentState\n}\n    "])));
export var Progress_For_HookDocument = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    query progress_for_hook($new_leadID: uuid!) {\n  progress(where: {new_leadID: {_eq: $new_leadID}}) {\n    ...progressFields\n  }\n}\n    ", ""], ["\n    query progress_for_hook($new_leadID: uuid!) {\n  progress(where: {new_leadID: {_eq: $new_leadID}}) {\n    ...progressFields\n  }\n}\n    ", ""])), ProgressFieldsFragmentDoc);
/**
 * __useProgress_For_HookQuery__
 *
 * To run a query within a React component, call `useProgress_For_HookQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgress_For_HookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgress_For_HookQuery({
 *   variables: {
 *      new_leadID: // value for 'new_leadID'
 *   },
 * });
 */
export function useProgress_For_HookQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(Progress_For_HookDocument, options);
}
export function useProgress_For_HookLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(Progress_For_HookDocument, options);
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlUHJvZ3Jlc3MuZ3FsLmpzeCIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInVzZVByb2dyZXNzLmdxbC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7O0FBRUEsT0FBTyxFQUFFLEdBQUcsRUFBRSxNQUFNLGdCQUFnQixDQUFDO0FBQ3JDLE9BQU8sS0FBSyxNQUFNLE1BQU0sZ0JBQWdCLENBQUM7QUFDekMsSUFBTSxjQUFjLEdBQUcsRUFBVyxDQUFDO0FBVW5DLE1BQU0sQ0FBQyxJQUFNLHlCQUF5QixHQUFHLEdBQUcsOEpBQUEsMkZBTXZDLElBQUEsQ0FBQztBQUNOLE1BQU0sQ0FBQyxJQUFNLHlCQUF5QixHQUFHLEdBQUcsd05BQUEsaUpBTXRDLEVBQXlCLEVBQUUsS0FBM0IseUJBQXlCLENBQUUsQ0FBQztBQUVsQzs7Ozs7Ozs7Ozs7Ozs7O0dBZUc7QUFDSCxNQUFNLFVBQVUseUJBQXlCLENBQUMsV0FBNkY7SUFDL0gsSUFBTSxPQUFPLHlCQUFPLGNBQWMsR0FBSyxXQUFXLENBQUMsQ0FBQTtJQUNuRCxPQUFPLE1BQU0sQ0FBQyxRQUFRLENBQTBELHlCQUF5QixFQUFFLE9BQU8sQ0FBQyxDQUFDO0FBQ3RILENBQUM7QUFDUCxNQUFNLFVBQVUsNkJBQTZCLENBQUMsV0FBa0c7SUFDdEksSUFBTSxPQUFPLHlCQUFPLGNBQWMsR0FBSyxXQUFXLENBQUMsQ0FBQTtJQUNuRCxPQUFPLE1BQU0sQ0FBQyxZQUFZLENBQTBELHlCQUF5QixFQUFFLE9BQU8sQ0FBQyxDQUFDO0FBQzFILENBQUMifQ==